import api from 'Application/api/api';

const declineEpcOfferFromPortal = async (signal, id) => {
	const response = await api.patch(`/epc-offers/partner/${id}/decline`, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
		data: response.data,
	};
};

export default declineEpcOfferFromPortal;
